import { render, staticRenderFns } from "./PHQ.vue?vue&type=template&id=c537693c&scoped=true&"
import script from "./PHQ.vue?vue&type=script&lang=js&"
export * from "./PHQ.vue?vue&type=script&lang=js&"
import style0 from "./PHQ.vue?vue&type=style&index=0&id=c537693c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c537693c",
  null
  
)

export default component.exports